import { render } from "./addCampaign.vue?vue&type=template&id=6b10d5e2"
import script from "./addCampaign.vue?vue&type=script&lang=js"
export * from "./addCampaign.vue?vue&type=script&lang=js"

import "./addCampaign.vue?vue&type=style&index=0&id=6b10d5e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__